/* global Backbone, Marionette */
/* eslint-disable no-var, object-shorthand */
var nfRadio = Backbone.Radio;

/**
 * Front-end entry point for the conversational display.
 */
require( [ 'controllers/formContent' ], function ( FormContentController ) {
	var ConversationalForms = Marionette.Application.extend( {
		/**
		 * Wait for Ninja Forms to start building a form.
		 *
		 * @return {void}
		 */
		initialize: function () {
			this.listenTo(
				nfRadio.channel( 'form' ),
				'before:filterData',
				this.registerFormContent
			);
		},

		/**
		 * Register the content view controller for the form being built.
		 *
		 * This runs per form rather than once at start-up, so a page with
		 * several forms on it gets the filter registered for each of them.
		 *
		 * @return {void}
		 */
		registerFormContent: function () {
			new FormContentController();
		},
	} );

	var application = new ConversationalForms();
	application.start();
} );

define("main", function(){});

